import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DatetimePickerBase, DatetimePickerContent, DatetimePickerControl } from './datetime-picker-base';
import { RANGE_DATETIME_SELECTION_MODEL_PROVIDER, DatetimeRange } from './datetime-selection-model';
import { CALENDAR_RANGE_STRATEGY_PROVIDER } from './datetime-range-selection-strategy';

/**
 * Input that can be associated with a date range picker.
 * @docs-private
 */
export interface DatetimeRangePickerInput<D> extends DatetimePickerControl<D> {
  _getEndDateAccessibleName(): string | null;
  _getStartDateAccessibleName(): string | null;
  comparisonStart: D | null;
  comparisonEnd: D | null;
}

/** Component responsible for managing the date range picker popup/dialog. */
@Component({
  selector: 'app-datetime-range-picker',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    RANGE_DATETIME_SELECTION_MODEL_PROVIDER,
    CALENDAR_RANGE_STRATEGY_PROVIDER,
    { provide: DatetimePickerBase, useExisting: DatetimeRangePicker },
  ],
})
export class DatetimeRangePicker<D> extends DatetimePickerBase<
  DatetimeRangePickerInput<D>,
  DatetimeRange<D>,
  D
> {
  protected override _forwardContentValues(instance: DatetimePickerContent<DatetimeRange<D>, D>) {
    super._forwardContentValues(instance);

    const input = this.datepickerInput;

    if (input) {
      instance.comparisonStart = input.comparisonStart;
      instance.comparisonEnd = input.comparisonEnd;
      instance.startDateAccessibleName = input._getStartDateAccessibleName();
      instance.endDateAccessibleName = input._getEndDateAccessibleName();
    }
  }
}
